import React from 'react';
import { Download, FileSearch } from 'lucide-react';
import { Card, SectionTitle } from '../ui';
import { downloadFile, fmtDateTime } from '../api';
import { STATUS } from './RequestsList';
import ConsPicker from './ConsPicker';
import FormalitaPicker from './FormalitaPicker';

const M_STATUS = { ...STATUS, listed: ['Elenco pronto', 'text-green-400 border-green-900'], empty: ['Nessuna formalità', 'text-[#C9CCD1] border-[#1F242C]'] };

function Notes({ req }) {
  if (!req.notes.length) return null;
  return (
    <div className="mt-4 border-t border-[#1F242C] pt-4 space-y-2" data-testid={`mortgage-notes-${req.id}`}>
      <p className="text-[11px] uppercase tracking-[0.18em] text-[#5A5F67]">Note richieste</p>
      {req.notes.map((n) => {
        const [label, cls] = M_STATUS[n.status] || [n.status, ''];
        return (
          <div key={n.id} className="flex flex-wrap items-center gap-3 text-xs" data-testid={`mortgage-note-${n.id}`}>
            <span className="flex-1 min-w-[200px] text-[#C9CCD1]">{n.label}{n.message && <span className="block text-[#5A5F67]">{n.message}</span>}</span>
            <span className={`text-[10px] font-mono uppercase px-2 py-0.5 border rounded-sm ${cls}`}>{label}</span>
            {n.file && (
              <button onClick={() => downloadFile(`/property/mortgage/${req.id}/notes/${n.id}/file`, n.file.name)} className="h-8 px-3 inline-flex items-center gap-2 border border-[#1F242C] rounded-sm text-[#E5E5E5] hover:border-[#D4AF37] transition-colors" data-testid={`mortgage-note-download-${n.id}`}>
                <Download size={13} />Scarica
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default function MortgageList({ items, prices, onDone }) {
  return (
    <div className="mt-10" data-testid="mortgage-requests">
      <SectionTitle>Le mie ispezioni ipotecarie</SectionTitle>
      {!items.length && <p className="text-sm text-[#5A5F67]" data-testid="mortgage-requests-empty">Nessuna ispezione richiesta finora.</p>}
      <div className="space-y-3">
        {items.map((r) => {
          const [label, cls] = M_STATUS[r.status] || [r.status, ''];
          return (
            <Card key={r.id} className="p-5" data-testid={`mortgage-request-${r.id}`}>
              <div className="flex flex-wrap items-center gap-4">
                <FileSearch size={18} className="text-[#D4AF37] shrink-0" />
                <div className="flex-1 min-w-[200px]">
                  <p className="text-sm text-[#F2F2F2] truncate">{r.name}</p>
                  <p className="text-xs font-mono text-[#5A5F67]">{r.code} · {fmtDateTime(r.created_at)}</p>
                  {r.message && <p className="text-xs text-[#8A8F97] mt-1" data-testid={`mortgage-request-message-${r.id}`}>{r.message}</p>}
                </div>
                <span className={`text-[10px] font-mono uppercase tracking-wider px-2 py-1 border rounded-sm ${cls}`} data-testid={`mortgage-request-status-${r.id}`}>{label}</span>
              </div>
              {r.status === 'listed' && <ConsPicker req={r} price={prices.property_mortgage?.cents} onDone={onDone} />}
              {r.conservatorie.filter((c) => c.status === 'ready').map((c) => <FormalitaPicker key={c.code} req={r} cons={c} price={prices.property_mortgage_note?.cents} onDone={onDone} />)}
              <Notes req={r} />
            </Card>
          );
        })}
      </div>
    </div>
  );
}
